import AuthService from "../login/auth.service";
import axios from "axios";
import { compromisoSocio } from "../../components/generico/utils/UrlAPI";

class PagoSolidaridadService {
  async pagosSeleccionados(_codigoProducto) {
    var data = JSON.stringify({ canal: "WEB", modo: "S" });
    var config = {
      method: "post",
      url: compromisoSocio+"solidaridad/pagoSolidaridad",
      headers: {
        "Content-Type": "application/json",
        "Authorization":"Bearer "+AuthService.getCurrentToken(),
      },
      data: data,
    };

    return await axios(config);
  }

  async pagosConfirmados(_cuentaDebito, _importeEfectivo, _codigoProducto) {
    //falta numero de operacion
    var data = JSON.stringify({
      canal:"WEB",
      cuentaDebito: _cuentaDebito,
      importeDebito: _importeEfectivo
    });

    var config = {
      method: "post",
      url: compromisoSocio+"solidaridad/pagoSolidaridad",
      headers: {
        "Content-Type": "application/json",
        "Authorization":"Bearer "+AuthService.getCurrentToken(),
      },
      data: data,
    };

    return await axios(config);
  }
}
export default new PagoSolidaridadService();
